import { request } from "../utils/request.js"

export const doctor_addNew = (pojo, args) => request({
    url: 'doctor/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})
export const doctor_update = (pojo, args) => request({
    url: 'doctor/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const doctor_findByPageForManage = (pojo, args) => request({
    url: 'doctor/findByPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const doctor_findListForManage = (pojo, args) => request({
    url: 'doctor/findListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const doctor_findByPageForSelect = (pojo, args) => request({
    url: 'doctor/findByPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const doctor_findListForSelect = (pojo, args) => request({
    url: 'doctor/findListForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


export const doctor_changeFrozenStatus = (id, args) => request({
    url: 'doctor/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const doctor_deleteById = (id, args) => request({
    url: 'doctor/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const doctor_findById = (id, args) => request({
    url: 'doctor/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/doctor.js